<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import { useNoQrcodeOverlay } from '@/store/overlays/no-qr-code-overlay.ts';

const store = useNoQrcodeOverlay();
const { name } = useDisplay();
const { t } = useI18n();

const card_width = computed((): string => {
  switch (name.value) {
    case "xs":
    case "sm":
      return "w-100";
    default:
      return "w-50";
  }
});
</script>

<template>
  <v-dialog
    v-model="store.is_visible"
    no-click-animation
    persistent
    z-index="900"
    style="background-color: rgba(0, 0, 0, 0.4)"
    @click:outside="store.show"
  >
  <v-container :class="`pa-0 ${card_width}`" fill-height fluid>
      <v-row>
        <v-col>
          <v-card class="bg-card-background mx-3">
            <v-card-title class="bg-primary font-weight-bold">
              {{ t("title") }}
            </v-card-title>
            <v-divider />
            <v-card-subtitle class="pt-4 text-wrap">
              {{ t("message") }}
            </v-card-subtitle>
            <v-card-text class="pl-10 text-info">
              <ul>
                <li>{{ t("scan") }}</li>
                <li>{{ t("goto") }}</li>
                <li>{{ t("login") }}</li>
                <li>{{ t("plugin") }}</li>
                <li>{{ t("start") }}</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<i18n lang="yaml">
en:
  title: "Error"
  message: "The browser lost the informations about the chargepoint you are charging on"
  scan: "Scan station's QR code"
  goto: "Go to the given url"
  login: "Log in with an authorized account or pay with a card"
  plugin: "Plug in your cable"
  start: "Start your charge!"
it:
  title: "Errore"
  message: "Il browser ha perso le informazioni relative alla colonnina."
  scan: "Scansiona il QR code della colonnina"
  goto: "Vai al link generato"
  login: "Accedi con un account autorizzato o paga con una carta"
  plugin: "Inserisci il cavo per la ricarica"
  start: "Avvia la carica!"
fr:
  title: "Erreur"
  message: "Le navigateur a perdu les informations sur la borne sur laquelle vous chargez"
  scan: "Scannez le QR code de la station"
  goto: "Rendez-vous à l'adresse obtenue"
  login: "Connectez-vous avec un compte autorisé ou payez avec une carte"
  plugin: "Branchez votre câble"
  start: "Démarrez votre charge!"
de:
  title: "Fehler"
  message: "Der Browser hat die Informationen verloren der Stromtankstelle"
  scan: "Scannen Sie den QR-Code der Stromtankstelle"
  goto: "Gehen Sie zum generierten link"
  login: "Melden Sie sich mit Ihren Zugangsdaten an oder zahlen Sie per Kreditkarte"
  plugin: "Ladekabel einstecken"
  start: "Beginnt zu laden!"
nl:
  title: "Fout"
  message: "De browser heeft informatie verloren over het laadpunt waaraan u oplaadt."
  scan: "Scan de QR-code van het station"
  goto: "Ga naar het verkregen adres"
  login: "Meld u aan met een toegelaten account of betaal met een kaart"
  plugin: "Sluit uw kabel aan"
  start: "Begin met opladen"
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
